"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { Divider } from "staysure-component-library";

import { useRegulatoryDisclaimerFooter } from "@/app/shared-components/regulatory-disclaimer-footer/regulatory-disclaimer-footer.hook";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import RichText from "@/components/atoms/rich-text/rich-text";

const CountryChangeFooter = dynamic(
  () => import("../country-change-footer/country-change-footer"),
  {
    ssr: false,
  }
);

const RegulatoryDisclaimerFooter = dynamic(
  () => import("../regulatory-disclaimer-footer/regulatory-disclaimer-footer"),
  {
    ssr: false,
  }
);

function QuestionFooterSection() {
  const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(false);
  const pathname = usePathname();
  const { wizard } = useWizard();
  const { productSpecialFeatures } = wizard;
  const { data: magnoliaData } = useRegulatoryDisclaimerFooter();
  const coverTypeFooterText = magnoliaData?.coverTypeFooterText;

  const isCoverTypePage = pathname === "/" || pathname === "";
  const shouldShowCookiePolicy =
    isCoverTypePage && magnoliaData?.enabledCoverTypeFooterText;

  return (
    <>
      <div
        className={`flex flex-col items-center ${
          !isDisclaimerExpanded
            ? "lg:flex-row lg:justify-between"
            : "lg:flex-col lg:justify-between lg:items-start"
        }`}
      >
        <div className="w-full md:w-auto">
          {productSpecialFeatures?.showCountryFooter && <CountryChangeFooter />}
        </div>
        <div className="w-full md:w-auto">
          <RegulatoryDisclaimerFooter
            isExpanded={isDisclaimerExpanded}
            onExpandedChange={setIsDisclaimerExpanded}
          />
        </div>
      </div>
      {shouldShowCookiePolicy && (
        <div
          className={`lg:mx-[72px] xl:mx-0 md:mx-[48px] mx-[24px] ${
            isDisclaimerExpanded ? "mt-spacing-m" : "mt-spacing-l"
          } !pb-0`}
        >
          <Divider className="!mb-spacing-m" />

          <RichText
            richText={coverTypeFooterText || ""}
            className="text-center md:text-left lg:text-left font-body-font font-normal text-[14px] leading-[21px] whitespace-pre-line"
          />
        </div>
      )}
    </>
  );
}

export default QuestionFooterSection;
